import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { DefaultRoleSlug, RoleInterface, RoleInterfaceMap } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";
import { AlertsModel } from "../Notifications/Alerts.Model";

interface StoreInterface {
  defaultRoles?: RoleInterfaceMap;
  parentRoles?: RoleInterfaceMap;
  roles?: RoleInterfaceMap;
  rolesLoaded?: boolean;
}

const BlankState: StoreInterface = {
  roles: undefined,
  defaultRoles: undefined,
  parentRoles: undefined,
  rolesLoaded: false
};

export default class RolesModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = RolesModel.useState.setState;
  static get state() {
    return RolesModel.useState.getState();
  }
  static reset() {
    RolesModel.setState({ ...BlankState });
  }

  static loadRoles(orgIdToLoad?: number) {
    if (!orgIdToLoad && !Member.orgId) {
      warn("Cannot load roles without orgId", Member.orgId, orgIdToLoad);
      return;
    }
    const orgId = orgIdToLoad || Member.orgId;
    if (!orgId) {
      warn("No org id");
      return;
    }
    return API.Roles.loadRoles(orgId).then((data: { defaultRoles: RoleInterfaceMap; parentRoles: RoleInterfaceMap; roles: RoleInterfaceMap }) => {
      RolesModel.setState({
        roles: data.roles,
        defaultRoles: data.defaultRoles,
        parentRoles: data.parentRoles,

        rolesLoaded: true
      });
    });
  }

  static mergedActionsForRole(role: RoleInterface) {
    if (role.parentSlug) {
      const parent = RolesModel.state.defaultRoles?.[role.parentSlug] ?? RolesModel.state.parentRoles?.[role.parentSlug];
      if (parent) {
        return { ...parent.actions, ...role.actions };
      }
    }
    return role.actions;
  }

  static updateRole(role: Partial<RoleInterface>) {
    if (!role.id || !role.slug) {
      warn("Cannot update role without id");
      return;
    }
    let roles = RolesModel.state.roles;
    if (!roles) {
      warn("Cannot update role without roles");
      return;
    }

    roles[role.slug] = { ...roles[role.slug], ...role };
    RolesModel.setState({ roles });

    API.Roles.updateRole(Member.orgId!, role.id, role)
      .then((role: RoleInterface) => {})
      .catch((error) => {
        RolesModel.loadRoles();
        AlertsModel.errorToast("Error updating role");
      });
  }

  static createRole(name: string, parentSlug: DefaultRoleSlug) {
    API.Roles.createRole(Member.orgId, name, parentSlug)
      .then((role: RoleInterface) => {
        RolesModel.loadRoles();
      })
      .catch((error) => {
        RolesModel.loadRoles();
        AlertsModel.errorToast("Error creating role");
      });
  }
  static deleteRole(roleId: number) {
    if (!roleId) {
      warn("Cannot delete role without id");
      return;
    }
    return API.Roles.deleteRole(Member.orgId!, roleId)
      .then((_) => {
        return RolesModel.loadRoles();
      })
      .catch((error) => {
        RolesModel.loadRoles();
        AlertsModel.errorToast("Error deleting role");
      });
  }
}
